import React from 'react';
import Icon from '../../../../../elements/icons/Icon';

// TODO: move style to scss file
const buttonStyle = {
    borderRadius: 4,
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    textTransform: 'unset',
};

const WaitingRoomButton = (props) => {
    const { i18n, activeParticipants, color } = props;

    return (
        <button
            className={`blocklink text  `}
            onClick={() => openWaitingRoom()}
            style={{
                ...buttonStyle,
                marginLeft: 10,
                background: 'white',
                color: color,
            }}>
            {i18n['label.waiting_room']}
            <Icon
                src="img/event_participants.png"
                color={color}
                size={20}
                style={{
                    marginLeft: 10,
                    position: 'relative',
                    opacity: 0.8,
                }}>
                <div
                    className="Bubble"
                    style={{
                        bottom: '-8px',
                        left: '12px',
                    }}>
                    {activeParticipants.length}
                </div>
            </Icon>
        </button>
    );

    function openWaitingRoom() {
        app.store.dispatch(app.actions.ui.sidePanel.maximize(true));
    }
};

export default WaitingRoomButton;
